import React from 'react';
import { TruckIcon, PackageOpen, Recycle, Factory, BarChart3, Settings } from 'lucide-react';

const ServizioCard = ({ icon: Icon, titolo, descrizione, immagine, indice }) => {
  return (
    <div className={`group relative overflow-hidden rounded-lg shadow-lg transition-all duration-500 hover:shadow-xl ${indice % 2 === 0 ? 'transform hover:-translate-y-2' : 'transform hover:translate-y-2'}`}>
      {/* Immagine di sfondo */}
      <div className="absolute inset-0 ">
        <img
          src={immagine}
          alt={titolo}
          className="w-full h-full object-cover opacity-40 group-hover:opacity-50 group-hover:scale-105 transition-all duration-700"
        />
      </div>
        
      {/* Contenuto */}
      <div className="relative h-full p-8 flex flex-col justify-end z-10">
        <div className="p-3 bg-white/10 backdrop-blur-sm rounded-full w-12 h-12 flex items-center justify-center mb-4 group-hover:bg-white/20 transition-all duration-300">
          <Icon size={24} className="text-white" />
        </div>
        
        <h3 className="text-xl font-bold text-white mb-3">{titolo}</h3>
        <p className="text-gray-300">{descrizione}</p>
      </div>
    </div>
  );
};

const Servizi = () => {
  const serviziList = [
  //    {
  //      icon: PackageOpen,
  //      titolo: "Raccolta e Smistamento",
  //      descrizione: "Raccolta efficiente e smistamento professionale di sottoprodotti metallici industriali con attrezzature all'avanguardia.",
  //      immagine: "/images/servizi_1.webp"
  //    },
    {
      icon: TruckIcon,
      titolo: "Logistica Integrata",
      descrizione: "Gestione completa di tutte le fasi logistiche, dal ritiro alla consegna dei materiali, con flotta di mezzi dedicata.",
      immagine: "/images/servizi_2.webp"
    },
  //    {
  //      icon: Recycle,
  //      titolo: "Riciclo e Recupero",
  //      descrizione: "Soluzioni innovative per il riciclo e il recupero di materiali metallici, contribuendo all'economia circolare.",
  //      immagine: "/images/servizi_3.webp"
  //    },
  //   {
  //     icon: Factory,
  //     titolo: "Lavorazione Materiali",
  //     descrizione: "Processi di lavorazione specializzati per adattare i materiali metallici alle specifiche esigenze dei clienti.",
  //     immagine: "/images/servizi_4.webp"
  //   },
    {
      icon: BarChart3,
      titolo: "Consulenza Tecnica",
      descrizione: "Analisi e valutazione dei materiali metallici più adatti alle tue esigenze produttive, con supporto tecnico specializzato e studi di fattibilità.",
      immagine: "/images/servizi_5.webp"
    },
    {
      icon: Settings,
      titolo: "Soluzioni Personalizzate",
      descrizione: "Sviluppo di soluzioni su misura per ottimizzare i processi produttivi della tua azienda in base alle specifiche necessità.",
      immagine: "/images/servizi_6.webp"
    },
  ];

  // Funzione che divide i servizi in righe di 2 elementi ciascuna
  const totalServices = serviziList.length;
  const rows = [];
  
  // Distribuisci gli elementi in righe da 2
  for (let i = 0; i < totalServices; i += 2) {
    if (i + 1 < totalServices) {
      // Aggiungi una riga completa con 2 elementi
      rows.push(serviziList.slice(i, i + 2));
    } else {
      // Aggiungi una riga con un solo elemento (l'ultimo, dispari)
      rows.push(serviziList.slice(i, i + 1));
    }
  }

  return (
    <section id="servizi" className="py-20 bg-gradient-to-b from-gray-600 to-gray-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center mb-4">
            <span className="w-12 h-[1px] bg-gray-400"></span>
            <span className="mx-4 text-gray-300 uppercase text-sm tracking-widest font-light">Cosa offriamo</span>
            <span className="w-12 h-[1px] bg-gray-400"></span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">I Nostri Servizi</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Mas Metal S.R.L. offre un'ampia gamma di servizi per supportare la tua attività industriale,
            garantendo efficienza, qualità e soluzioni personalizzate per ogni esigenza.
          </p>
        </div>
        
        {/* Layout dei servizi: 2 per riga, ultimo centrato se dispari */}
        <div className="max-w-6xl mx-auto">
          {rows.map((row, rowIndex) => (
            <div key={rowIndex} className="flex justify-center mb-8">
              <div className={`grid ${row.length === 1 ? 'grid-cols-1 max-w-lg' : 'grid-cols-1 md:grid-cols-2'} gap-8 w-full`}>
                {row.map((servizio, index) => (
                  <ServizioCard 
                    key={index}
                    indice={rowIndex * 2 + index}
                    icon={servizio.icon}
                    titolo={servizio.titolo}
                    descrizione={servizio.descrizione}
                    immagine={servizio.immagine}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <a href="#contatti" className="inline-block px-8 py-4 bg-white text-gray-900 font-medium rounded shadow-lg hover:bg-gray-200 transition-all duration-300">
            Richiedi informazioni sui nostri servizi
          </a>
        </div>
      </div>
    </section>
  );
};

export default Servizi;